/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import React from 'react';
import { PropTypes } from 'prop-types';
import { MdCircle } from 'react-icons/md';
import { formatNumericDate } from '../../../utils/dates';
import { getPriorityColor } from '../../../utils/api/site';

const Note = ({ note, onClickNote = () => {} }) => {
  const {
    priority, site_name, title, timestamp,
  } = note;

  return (
    <div
      onClick={() => onClickNote(note.id)}
      className="flex items-center relative py-2 px-4 text-black rounded-lg bg-vamos-v-light-gray mb-2 cursor-pointer hover:no-underline hover:text-black"
    >
      <h4 className="flex items-center text-base m-0 font-medium mr-4 gap-2 text-black min-w-[72px]">
        {formatNumericDate(timestamp)}
      </h4>
      <MdCircle size={16} color={getPriorityColor(priority)} className="w-4 h-4 flex-none" />
      <div className="flex items-center ml-4 flex-1 min-w-0">
        <span className="truncate min-w-0">
          <span className="text-base font-semibold">{title}</span>
          <span className="text-sm font-normal text-vamos-grey-70 ml-3">{`@ ${site_name}`}</span>
        </span>
      </div>
    </div>
  );
};

Note.propTypes = {
  note: PropTypes.object.isRequired,
  onClickNote: PropTypes.func,
};

export default Note;
